<template><div></div></template>
<script>
export default {
  name: 'GoogleMapCuadrillaPolyLine',
  props: {
    loader: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    routes: {
      type: Array,
      required: true
    },
    google: {
      type: Object,
      required: true
    }
  },

  mounted() {
    let path = []
    for (let i = 0; i < this.routes.length; i++) {
      const position = this.routes[i]
      path.push({ lat: parseFloat(position.rast_lat), lng: parseFloat(position.rast_lng) })
    }
    console.log('path:', path)
    const polyline = new this.google.Polyline({
      path: path,
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 2
    });
    console.log('polyline:', polyline)
    polyline.setMap(this.map);
  },

  methods: {
    showMoreDetails() {
      console.log('showMoreDetails Polyline')
    }
  }
}
</script>
